import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { whyUnique } from '../mockData_extended';
import { Award } from 'lucide-react';

const WhyUnique = () => {
  const { language } = useLanguage();
  const content = whyUnique[language] || whyUnique.en;

  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="flex items-center justify-center gap-4 mb-8">
          <div className="w-16 h-16 bg-gradient-to-br from-[#a8cef1] to-[#7eb3e3] rounded-full flex items-center justify-center">
            <Award className="w-8 h-8 text-white" />
          </div>
        </div>
        
        <h2 className="text-4xl md:text-5xl font-light text-slate-800 mb-8 text-center">
          {content.title}
        </h2>
        
        <div className="bg-gradient-to-br from-slate-50 to-white border border-slate-200 rounded-2xl p-8 md:p-12 shadow-lg">
          <p className="text-lg text-slate-700 leading-relaxed text-center">
            {content.text}
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyUnique;
